import {useId, useMemo} from 'react';
import {getBoundingRect} from '../../../tiptap/libs';

import {Rect} from '../../types';
import {RndRect} from './RndRect';

interface RectsProps {
  rects?: Rect[];
  boundingId?: string;
  edit?: boolean;
}

interface BoundingRectProps {
  rect: {x: number; y: number; width: number | string; height: number | string};
  boundingId?: string;
}

export const BoundingRect = ({rect, boundingId}: BoundingRectProps) => {
  const nodeId = useMemo(() => `rect-bounding-${boundingId}`, [boundingId]);

  return (
    <div
      className="absolute"
      id={nodeId}
      style={{width: rect.width, height: rect.height, top: rect.y, left: rect.x}}
    />
  );
};

export const Rects = ({edit = true, rects, boundingId}: RectsProps) => {
  const id = useId();

  const boundingRect = useMemo(() => {
    return getBoundingRect(rects?.filter((rect) => rect.type !== 'blur') ?? []);
  }, [rects]);

  return (
    <div className="rects-parent absolute inset-0">
      {rects?.map((rect, index) => (
        <RndRect
          key={`${boundingId}-${index}-${rect.type}-${id}`}
          index={index}
          rect={rect}
          edit={edit}
        />
      ))}

      {!edit &&
        (boundingRect ? (
          <BoundingRect rect={boundingRect} boundingId={boundingId} />
        ) : (
          <BoundingRect
            rect={{x: 0, y: 0, width: '100%', height: '100%'}}
            boundingId={boundingId}
          />
        ))}
    </div>
  );
};
